export function validateText({ text, bannedCharacters }) {
  if (!text) {
    return {
      valid: false,
      error: "The text should not be empty"
    };
  }

  if (!bannedCharacters?.length) {
    return {
      valid: true,
      error: "The are no banned characters to test"
    };
  }

  const errors = bannedCharacters.filter((char) => text.includes(char));

  if (errors?.length) {
    return {
      valid: false,
      error: `The text contains invalid characters: ${errors.join()}`
    };
  }

  return { valid: true };
}
